<h2>{{ label }} Address</h2>
<div [formGroup]="form" class="grid grid-cols-1 grid-rows-4 gap-4 @2xl:grid-cols-4 @2xl:grid-rows-2">
  <app-boomer-text-input
    [form]="form"
    formControlName="addressLine1"
    [label]="label + ' Address Line 1 (No PO Box)'"
    class="col-span-1 @2xl:col-span-2"
  ></app-boomer-text-input>
  <app-boomer-text-input
    [form]="form"
    formControlName="addressLine2"
    [label]="label + ' Address Line 2'"
    class="col-span-1 @2xl:col-span-2"
  ></app-boomer-text-input>
  <app-boomer-text-input
    [form]="form"
    formControlName="city"
    label="City"
    class="col-span-1 @2xl:col-span-1"
  ></app-boomer-text-input>
  <div class="col-span-1 @2xl:col-span-1">
    <app-boomer-text-input [form]="form" formControlName="zipCode" label="Zip"></app-boomer-text-input>
  </div>
  <app-boomer-county-fips-field
    [form]="form"
    [zipCodeControl]="form.get('zipCode')"
    label="County"
    countyControlName="countyName"
    fipsControlName="fipsCode"
    [savedAddress]="savedAddress"
    (loadingChange)="isLoadingCounties = $event"
    class="col-span-1 @2xl:col-span-1"
  >
  </app-boomer-county-fips-field>
  <div class="col-span-1 @2xl:col-span-1">
    <app-boomer-text-input [form]="form" formControlName="state" label="State" readonly />
    @if (isLoadingCounties) {
      <mat-progress-bar mode="indeterminate" />
    }
  </div>
</div>
